import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { SectionLabel, Button } from "../components/Primitives";

export default function PaymentCancel() {
  return (
    <div className="mx-auto max-w-xl px-6 py-20 md:px-12" data-testid="payment-cancel-page">
      <div className="border border-edge bg-ash p-8 text-center md:p-10">
        <XCircle className="mx-auto h-10 w-10 text-muted" />
        <SectionLabel>Checkout Cancelled</SectionLabel>
        <p className="mt-3 text-muted">No charge was made. You can upgrade to Premium anytime.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/premium"><Button variant="gold" data-testid="payment-cancel-retry-btn">Try Again</Button></Link>
          <Link to="/"><Button variant="outline" data-testid="payment-cancel-home-btn">Back Home</Button></Link>
        </div>
      </div>
    </div>
  );
}
